import { Testimonial } from '../types/article'

export const testimonials: Testimonial[] = [
  {
    name: 'Dana',
    age: 42,
    breed: 'Beagle',
    property: 'Half-acre suburban lot, no back fence',
    quote:
      'My beagle followed a rabbit trail out of our yard twice a week for a year. He hit the beep on the second day and stopped dead. He has not left the yard since March.',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/a1101105-e8d3-476a-8cd1-9fc35ef4f47c.jpg',
  },
  {
    name: 'Ray',
    age: 55,
    breed: 'German Shepherd',
    property: 'Four acres of open land, cattle fence only',
    quote:
      'I could never fence four acres. I walked the boundary in fifteen minutes and it held tight, right where I put it. No wire, no trenching, no monthly bill.',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/26e6f6ac-a3a1-4a47-a027-554c29687ec1.jpg',
  },
  {
    name: 'Kelsey',
    age: 29,
    breed: 'Chocolate Labrador',
    property: 'Corner lot on a busy street',
    quote:
      'We live on a corner with traffic on two sides, so every escape was terrifying. She learned the line in four days and has never needed anything past the vibration.',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/abd3bbac-dc86-41f7-ab1c-703817751373.jpg',
  },
  {
    name: 'Tom',
    age: 38,
    breed: 'Border Collie',
    property: 'Small farm, three sides open to fields',
    quote:
      'A border collie will work a field until dark if you let him. This gave him room to run and gave me an edge he actually respects. Best money I have spent on him.',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/46556dcb-380d-4e92-b76e-ce00d1fbb3d1.jpg',
  },
  {
    name: 'Priya',
    age: 47,
    breed: 'Boxer',
    property: 'HOA neighborhood, four-foot fence',
    quote:
      'Our HOA capped fence height at four feet, which a boxer treats as a suggestion. Two weeks in and I stopped standing at the window watching him.',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/ac35bf85-7b49-417f-97ae-965f7a8edaa9.jpg',
  },
]
